export default { sha: '3eda2fd57239985b672f4bb5ae538b780f33062b', buildNumber: 'undefined' }
